import { ITrazabilidad } from '../interfaces/erp/global/trazabilidad.interface';
import { calcTrazavilidad } from './calc-trazabilidad.utils';
import { formatCurrency, formatQuantity } from './format-currency.utils';
import { formatDate, formatDateWithTime, formatDateWithTimeAMPM } from './format-date';

export const emptyCellOneLevel = (
  row: any,
  key: string,
  defaultValue: string = '—'
) => {
  const value = row?.original?.[key];
  return !!value ? value : defaultValue;
};

export const emptyCell = (value?: string | number | null, defaultValue: string = '—') => {
  return !!value ? value : defaultValue;
};

export const formatCurrencyCell = (row: any, key: string) => {
  const value = row?.original?.[key];
  return !!value ? formatCurrency(value) : formatCurrency(0);
};
export const formatPercentageCell = (row: any, key: string) => {
  const value = row?.original?.[key];
  return !!value ? `${value}%` : '—';
};

export const formatDateCell = (row: any, key: string) => {
  const value = row?.original?.[key];
  return !!value ? formatDate(value) : '—';
};

export const formatDateWithTimeCell = (row: any, key: string) => {
  const value = row?.original?.[key];
  return !!value ? formatDateWithTime(value) : '—';
};

export const calcTrazavilidadCell = (
  trazabilidadArr: ITrazabilidad[],
  targetUser: string,
  targetAction: string,
  targetField: keyof ITrazabilidad
): string => {
  const trazabilidad = calcTrazavilidad(
    trazabilidadArr,
    targetUser,
    targetAction,
    targetField
  );

  return !!trazabilidad ? trazabilidad : '—';
};

export const formatQuantityCell = (row: any, key: string) => {
  const value = row?.original?.[key];
  return !!value ? formatQuantity(value) : '—';
};

/**
 * Obtiene un valor de un objeto usando ruta anidada ('nivel1.nivel2.nivel3')
 */
export const getNestedValue = (obj: any, path: string) => {
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
};

/**
 * Formatea fecha y hora desde rutas anidadas
 */
export const formatNestedDateWithTimeCell = (row: any, key: string) => {
  const value = getNestedValue(row.original, key);
  return value ? formatDateWithTimeAMPM(value) : '—';
};


export function emptyCellObject<T,K extends keyof T>(
  obj: T | null | undefined,
  key: K,
  fallback: string = "—",
): string {
  if (obj == null) return fallback;

  const value = obj[key];

  // Considera vacío: null, undefined, string vacío
  if (value == null) return fallback;
  if (typeof value === "string" && value.trim() === "") return fallback;

  return String(value);
}

